import { useQuery } from '@tanstack/react-query';
import { GameService } from '../services';
import { queryKeys } from './query-keys';
function useGameTeamsQuery(gameId, {
  groupIds,
  query
} = {}) {
  return useQuery({
    queryKey: queryKeys.gameTeams.detail(gameId, groupIds),
    queryFn: () => GameService.getTeams(gameId, {
      groupIds,
      query
    }),
    enabled: gameId !== undefined,
    staleTime: Infinity
  });
}
export default useGameTeamsQuery;